import { Box, Input, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { ValidationError } from "./constants";
import { useURLInputState } from "./urlInputAtom";

interface Props {
    error?: ValidationError;
    onChange: () => void;
}

export const URLInput: FunctionComponent<Props> = (props) => {
    const {
        inputUrlCms: { urlInputTitle, emptyUrl, invalidUrl, importListingInputError },
    } = usePropertySelectionViewModelValue();

    const [url, setURL] = useURLInputState();

    const handleInputUrl = (url: string) => {
        setURL((p) => ({
            ...p,
            sanitizedUrl: url,
        }));
    };

    const validationErrorMapping = () => {
        if (props.error === ValidationError.NoURLEntered) return emptyUrl;
        if (props.error === ValidationError.InvalidURLEntered) return invalidUrl;
        if (props.error === ValidationError.IncorrectUrl) {
            return (
                <Box display="flex" flexDirection="column" gap="4">
                    <Typography variant="caption-default">{importListingInputError}</Typography>
                    <ul
                        style={{
                            margin: 0,
                        }}
                    >
                        <li>https://www.airbnb.com/xxx</li>
                        <li>https://www.booking.com/xxx</li>
                    </ul>
                </Box>
            );
        }

        return null;
    };

    return (
        <Input
            label={urlInputTitle}
            persistentLabel={false}
            value={url.sanitizedUrl}
            onChange={(e) => {
                handleInputUrl(e.currentTarget.value);
                props.onChange();
            }}
            clearLabel="Clear"
            // @ts-expect-error helperText can actually accept Element but Drone is too stupid to understand that
            helperText={validationErrorMapping()}
            intent={props.error === null || props.error === ValidationError.TechnicalIssue ? undefined : "error"}
            data-element-name="url-input-field"
        />
    );
};
